import { AlmeResponseNext } from "@alme/types/response/AlmeResponse";
import { AlmeConfig } from "../models/AlmeConfig";
import { AlmeApiUtils } from "../api/AlmeApiUtils";
import { AlmeAppState, AlmeSavedAppState } from "../components/AlmeApp/AlmeAppState";
import useRecursiveTimeout from "./useRecursiveTimeout";
import { MutableRefObject } from "react";

export function useSyncLastEntry(almeState: AlmeAppState,
    apiUtils: MutableRefObject<AlmeApiUtils>,
    almeConfig: AlmeConfig,
    setAlmeStateWrapper: (state: AlmeAppState) => void,
    getCurrentAppState: () => AlmeSavedAppState | null,
    loadAlmeHistory: (almeApiUtils: AlmeApiUtils, almeState: AlmeAppState) => Promise<AlmeResponseNext[]>,
): void {
    useRecursiveTimeout(async () => {
        if (almeState.history.length) {
            const curAppState = getCurrentAppState();
            const lastResponse = almeState.history.slice(-1)[0];
            const lastEntryId = lastResponse?.extensionData?.entryId as string | undefined;
            const currentLastEntryId = curAppState?.lastEntryId;

            if (lastEntryId !== currentLastEntryId && lastResponse.responseRevision > 0) {
                const history = await loadAlmeHistory(apiUtils.current, almeState);

                setAlmeStateWrapper({
                    ...almeState,
                    history,
                    launchQuestion: undefined,
                });
            }
        }
    }, almeConfig.lastEntryIdInterval);
}
